import Hero from "../components/Hero/Hero";
import TrustedClients from "../components/TrustedClients/TrustedClients";
import About from "../components/About/About";
import Statistics from "../components/Statistics/Statistics";
import ServicesPreview from "../components/ServicesPreview/ServicesPreview";
import ConstructionProcess from "../components/ConstructionProcess/ConstructionProcess";
import FeaturedProjects from "../components/FeaturedProjects/FeaturedProjects";
import WhyChooseUs from "../components/WhyChooseUs/WhyChooseUs";
import Testimonials from "../components/Testimonials/Testimonials";
import Gallery from "../components/Gallery/Gallery";
import CTA from "../components/CTA/CTA";

const Home = () => {
  return (
    <>
      <Hero />

      <TrustedClients />

      <About />

      <Statistics />

      <ServicesPreview />

      <ConstructionProcess />

      <FeaturedProjects />

      <WhyChooseUs />

      <Testimonials />

      <Gallery />

      <CTA />
    </>
  );
};

export default Home;
